import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"180px"} }
const _hoisted_2 = { style: {"font-weight":"bold"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "title-c" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }

import { ref } from "vue";
import { getContractDetailInfo } from "@/api/home";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { fmoney } from "@/utils/tools";
import { insurance_liability, liabilityGroup } from "@/config/config";

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckContractInfo',
  setup(__props, { expose: __expose }) {

const open = ref<boolean>(false);
const tabsInfo = ref<Array<any>>([]);
const activeKey = ref();
const showModal = () => {
  activeKey.value = 0;
  open.value = true;
  getContractDetailInfo()
    .then((res) => {
      if (res.data.planPackageBriefList != null && tabsInfo.value.length == 0) {
        res.data.planPackageBriefList.map((foo: any) => {
          tabsInfo.value.push({
            name: foo.name,
            key: foo.level,
            liabilityList: foo.liabilityBriefList,
          });
        });
      }
    })
    .catch();
};

const handleOk = (e: MouseEvent) => {
  open.value = false;
};
__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      title: "保障方案",
      onOk: handleOk,
      width: "100%",
      style: {"max-width":"1440px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsInfo.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: index,
                tab: item.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.liabilityList, (Oitem, Oindex) => {
                        return (_openBlock(), _createElementBlock("div", { key: Oindex }, [
                          _createVNode(_component_a_col, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(insurance_liability)[Oitem.type]), 1),
                                (Oitem.type != 'HOSPITALIZATION_ALLOWANCE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                      (
                        Oitem.insuranceCoverageType == '' ||
                        Oitem.insuranceCoverageType == 'FIXED'
                      )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 保额：" + _toDisplayString(_unref(fmoney)(Oitem.insuranceCoverage)), 1))
                                        : _createCommentVNode("", true),
                                      (Oitem.insuranceCoverageType == 'MONTHLY_SALARY')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 保额：" + _toDisplayString(_unref(fmoney)(Oitem.monthlySalaryMultiple)) + "倍月薪 ", 1))
                                        : _createCommentVNode("", true),
                                      (Oitem.insuranceCoverageType == 'CUSTOMIZE')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                                              title: _withCtx(() => [
                                                _createTextVNode("每位员工配置不同保额，请查看人员管理了解详细信息。")
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_7, [
                                                  _createTextVNode(" 保额： "),
                                                  _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (Oitem.type in _unref(liabilityGroup))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 免赔额：" + _toDisplayString(_unref(fmoney)(Oitem.deductible)), 1))
                                  : _createCommentVNode("", true),
                                (Oitem.type in _unref(liabilityGroup))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 赔付比例：" + _toDisplayString(Oitem.maxPayoutRatio) + "% ", 1))
                                  : _createCommentVNode("", true),
                                (Oitem.type == 'HOSPITALIZATION_ALLOWANCE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 普通住院补贴金额" + _toDisplayString(Oitem.generalWardSubsidy) + "元/天 ", 1))
                                  : _createCommentVNode("", true),
                                (Oitem.type == 'HOSPITALIZATION_ALLOWANCE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " ICU住院补贴金额" + _toDisplayString(Oitem.icuWardSubsidy) + "元/天 ", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})